import emptyImage from 'v3/assets/svg/empty-image.svg';

import * as S from './styles';

export type EmptyTypes = {
  title: string;
  text: string;
};

const Empty = ({ title, text }: EmptyTypes) => (
  <S.Wrapper>
    <S.Image src={emptyImage} alt="" />
    <S.Title>{title}</S.Title>
    <S.Text>{text}</S.Text>
  </S.Wrapper>
);

export default Empty;
